module.exports = __webpack_public_path__ + "static/media/iconCantineYellow.c42e8ef5.svg";